import React from "react";
import { useAuth } from "@/context/AuthContext";
import { VerifyBanner } from "@/components/VerifyBanner";
import CustomerDashboard from "@/pages/dashboards/CustomerDashboard";
import TradeDashboard from "@/pages/dashboards/TradeDashboard";
import StaffDashboard from "@/pages/dashboards/StaffDashboard";
import AdminDashboard from "@/pages/dashboards/AdminDashboard";

export default function Dashboard() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <>
      <VerifyBanner />
      {user.role === "customer" && <CustomerDashboard />}
      {user.role === "trade" && <TradeDashboard />}
      {user.role === "staff" && <StaffDashboard />}
      {user.role === "admin" && <AdminDashboard />}
    </>
  );
}
